import React, { PropTypes } from 'react'
import Home from 'react-icons/lib/ti/home'

const Footer = ({ campus, color }) => (
  <div id="footer">
    <div className="row">
      <div className="col-xs-5">
        <span className="icon" style={{ color }}><Home /></span>
        <strong>{campus}</strong>
      </div>
      <div className="col-xs-7 text-right">
        Bohol Island State University<br />
        All Rights Reserved &copy; 2016
      </div>
    </div>
  </div>
)

Footer.propTypes = {
  campus: PropTypes.string,
  color: PropTypes.string,
}

export default Footer



// WEBPACK FOOTER //
// ./src/partials/Footer/index.js